<div class="question-wrapper" id="QuestionWraper">
  <h1 class="text-center without-help text-02-m-light text-01-d-light">
    {{ question.QuestionText }}
  </h1>
  <div class="form-control input" id="divPostalCode">
    <input
      type="tel"
      [(ngModel)]="postalCode"
      maxlength="5"
      (keyup)="GetCityByPostCode()"
      (keypress)="numberOnly($event)"
      (paste)="(false)"
      name="txtPostCode"
      id="txtPostCode"
      placeholder="Código Postal"
      class="text-input text-09-d-demibold"
      pattern="[0-9]*"
      [class.error]="!isValidPostalCode" />
    <p id="lblCity" class="result-txt text-center">
      {{ contractType.province }}
    </p>
  </div>
  <div class="col-md-12 col-sm-12 col-xs-12 error" [class.hidden]="isValidPostalCode">
    <p id="errorContainer">Por favor introduce un código postal correcto.</p>
  </div>
</div>
<button id="btnClose" class="btn solid-main" (click)="saveSectionAnswer()">Guardar</button>
